import { Type } from 'class-transformer';

export class LocationCheckInListModel
{

    CheckedInList: Array<string>;
    @Type(() => Date)
    Created: Date;

}